<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="mail-content-article-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Mail Article
            </h4>
          </div>

          <LoadingSpinner v-if="loading"/>

          <div class="modal-body" v-else>
            <div class="row">
              <div class="col-xs-9">
                <label class="control-label">
                  Name
                </label>
              </div>
              <div class="col-xs-9">
                <label class="control-label">
                  Email
                </label>
              </div>
            </div>

            <div v-for="(recipient, index) in data.recipients" class="row" style="margin-bottom: 10px;">
              <div
                  :class="['col-xs-9 form-group', (errors['recipients.'+index+'.name'] || []).length ? 'has-error':'']"
              >
                <input
                    v-model="recipient.name"
                    :disabled="isSent"
                    type="text"
                    :name="'recipients.' + index + '.name'"
                    :id="'recipients.' + index + '.name'"
                    class="form-control"
                >
              </div>

              <div
                  :class="['col-xs-9 form-group', (errors['recipients.'+index+'.address'] || []).length ? 'has-error':'']"
              >
                <input
                    v-model="recipient.address"
                    :disabled="isSent"
                    type="text"
                    :name="'recipients.' + index + '.address'"
                    :id="'recipients.' + index + '.address'"
                    class="form-control"
                >
              </div>

              <div class="col-xs-6">
                <button type="button" class="btn btn-default btn-block" :disabled="isSent" @click="data.recipients.splice(index, 1)">
                  Remove
                </button>
              </div>

              <div v-if="hasRecipientError(index)" class="col-xs-24 has-error">
                <span class="help-block">
                    {{ getRecipientErrors(index)[0] }}
                </span>
              </div>
            </div>

            <button type="button" class="btn btn-default btn-block" :disabled="isSent" @click="data.recipients.push({})">
              Add
            </button>

            <div v-if="isSent" style="background-color: #eeeeee; margin-top: 20px; padding: 10px;" v-html="data.content"/>

            <CkEditorFormGroup
                v-else
                v-model="data.content"
                name="content"
                label="Content"
                :error="(errors.content || [])[0]"
                style="margin-top: 10px"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black" :disabled="isSent">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import CkEditorFormGroup from '@/vendor/forms/FormGroups/Block/CkEditor'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'

export default {
  components: {CkEditorFormGroup, LoadingSpinner},

  props: {
    contentArticle: {
      required: true
    },

    portal: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      data: {},

      loading: true,
      isSent: false,
      errors: {}
    }
  },

  mounted() {
    this.listenForClose()

    this.load()
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    load() {
      this.loading = true

      http.get('/api/v2/content-articles/' + this.contentArticle.id + '/publication-notification')
          .then(response => {
            this.data = {
              content: response.data.data.attributes.content,
              recipients: response.data.data.attributes.recipients,
            }

            this.isSent = response.data.data.attributes.sent_at !== null
          })
          .catch(() => {
            this.data = {
              content: this.portal.attributes.article_publication_email_template,
              recipients: this.contentArticle.attributes.default_publication_mail_recipients.map(person => ({...person})),
            }
          })
          .finally(() => {
            this.loading = false
          })
    },

    submit() {
      http.put('/api/v2/content-articles/' + this.contentArticle.id + '/publication-notification', this.data)
          .then(response => {
            notify.success('The notification was saved')

            this.$emit('saved', response.data.data)

            $(this.$el).modal('hide')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    },

    reset() {
      this.errors = {}
    },

    hasRecipientError(index) {
      return this.getRecipientErrors(index).length > 0
    },

    getRecipientErrors(index) {
      return Object.entries(this.errors)
          .filter(entry => entry[0].startsWith('recipients.' + index + '.'))
          .reduce((result, entry) => [...result, ...entry[1]], [])
    }
  }
}
</script>
